import { PaymentMethodEnum } from '../../enums';

export enum WidgetTypeEnum {
  Text = 'text',
  Button = 'button',
  DropdownCalculator = 'dropdownCalculator',
  TwoFieldsCalculator = 'twoFieldsCalculator'
}


export enum PaymentWidgetEnum {
  SANTANDER_INSTALLMENT_AT = PaymentMethodEnum.SANTANDER_INSTALLMENT_AT,
  SANTANDER_INSTALLMENT = PaymentMethodEnum.SANTANDER_INSTALLMENT,
  SANTANDER_FACTORING_DE = PaymentMethodEnum.SANTANDER_FACTORING_DE,
  SANTANDER_INSTALLMENT_DK = PaymentMethodEnum.SANTANDER_INSTALLMENT_DK,
  SANTANDER_INSTALLMENT_NL = PaymentMethodEnum.SANTANDER_INSTALLMENT_NL,
  SANTANDER_INSTALLMENT_NO = PaymentMethodEnum.SANTANDER_INSTALLMENT_NO,
  SANTANDER_INSTALLMENT_SE = PaymentMethodEnum.SANTANDER_INSTALLMENT_SE,
  IVY = PaymentMethodEnum.IVY,
  GOOGLE_PAY = PaymentMethodEnum.GOOGLE_PAY,
  APPLE_PAY = PaymentMethodEnum.APPLE_PAY,
  ZINIA_INSTALLMENT = 'zinia_installment',
  ZINIA_INSTALLMENT_DE = 'zinia_installment_de',
  ZINIA_LENDING_DE = 'zinia_lending_de',
}
